import { useCallback } from 'react'

export interface UseContentBriefBlockKeyboardProps {
  isEditing: boolean
  handleBlockClick: () => void
  handleSave: () => void
  handleCancel: () => void
}

export interface UseContentBriefBlockKeyboardReturn {
  handleKeyDown: (e: React.KeyboardEvent) => void
  handleBlockKeyDown: (e: React.KeyboardEvent) => void
}

export const useContentBriefBlockKeyboard = ({
  isEditing,
  handleBlockClick,
  handleSave,
  handleCancel,
}: UseContentBriefBlockKeyboardProps): UseContentBriefBlockKeyboardReturn => {
  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === 'Enter' && e.metaKey) {
        e.preventDefault()
        handleSave()
      }
      if (e.key === 'Escape') {
        e.preventDefault()
        handleCancel()
      }
    },
    [handleSave, handleCancel]
  )

  const handleBlockKeyDown = useCallback(
    (e: React.KeyboardEvent): void => {
      if (e.key === 'Enter' && !isEditing) {
        e.preventDefault()
        handleBlockClick()
      }
    },
    [isEditing, handleBlockClick]
  )

  return { handleKeyDown, handleBlockKeyDown }
}
